import SettingsIcon from '@mui/icons-material/Settings';
import { Box, Card, CardContent, Typography, IconButton } from '@mui/material';
import { type FC, type ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  children: ReactNode;
  onSettingsClick: () => void;
}

const ChartCard: FC<ChartCardProps> = ({ title, children, onSettingsClick }) => (
  <Card
    sx={{
      height: '100%',
      '& .MuiCardContent-root': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    }}>
    <CardContent>
      <Box display='flex' alignItems='center' justifyContent='space-between' mb={3}>
        <Typography variant='h6' fontWeight='medium'>
          {title}
        </Typography>
        <IconButton
          onClick={onSettingsClick}
          size='small'
          sx={{
            transition: 'transform 0.2s',
            '&:hover': {
              transform: 'rotate(90deg)',
            },
          }}>
          <SettingsIcon />
        </IconButton>
      </Box>
      <Box flexGrow={1}>{children}</Box>
    </CardContent>
  </Card>
);

export default ChartCard;
